<template>
  <div class="mx-auto md:grid md:grid-cols-12 md:gap-x-5 md:px-16">
    <div class="space-y-6 sm:px-6 md:px-0 md:col-span-12">
      <h1 class="text-2xl font-semibold tracking-wider">Jobs</h1>
      <TabsWrapper>
        <Tab title="All Jobs">
          <Table :recruiterJobs="recruiterJobs" />
        </Tab>
        <Tab title="Post Job">
          <JobPostForm :jobType="jobType" />
        </Tab>
        <Tab title="Applications">application goes here / job activities</Tab>
      </TabsWrapper>
    </div>
  </div>
</template>
  <script>
import RecruitersLayout from "@/components/Layouts/RecruitersLayout.vue";
import { computed } from "vue";

export default {
  layout: RecruitersLayout,
};
</script>
<script setup>
import TabsWrapper from "../../components/Tab/TabsWrapper.vue";
import Tab from "../../components/Tab/Tab.vue";

import Table from "@/components/Recruiters/Jobs/Table.vue";
import JobPostForm from "../../components/Recruiters/Jobs/JobPostForm.vue";

const props = defineProps({
  jobType: Object,
  recruiterJobs: Object,
});

const { jobType, recruiterJobs  } = props;
</script>
